
import * as moment from 'moment';

export function getFormatTime(date: Date, type: string) {
  let startDate: any
  let endDate: any
  switch(type) {
    case 'date':
      startDate = moment(date).startOf('day')
      endDate = moment(date).endOf('day')
      break;
    case 'week':
      startDate = moment(date).startOf('week')
      endDate = moment(date).endOf('week')
      break;
    case 'month':
      startDate = moment(date).startOf('month')
      endDate = moment(date).endOf('month')
      break;
    case 'quarter':
      const quarter = Math.floor((moment(date).month() + 3) / 3);
      startDate = moment({ year: moment(date).year(), month: 3*(quarter - 1)}).startOf('month')
      endDate = moment({ year: moment(date).year(), month: 3*quarter - 1 }).endOf('month');
      break;
    case 'year':
      startDate = moment(date).startOf('year')
      endDate = moment(date).endOf('year')
      break;
    default:
      break;
  }
  
  return {
    startDate: startDate.format('yyyy-MM-DD HH:mm:ss'),
    endDate: endDate.format('yyyy-MM-DD HH:mm:ss')
  }
}

export function getxAxis(date: Date, type: string) {
    let res = []
    switch(type) {
      case 'date':
        let i = 0;
        while (i <= 23) {
          let str = '0' + i
          res.push(str.slice(str.length - 2) )
          i++
        }
        this.xAxisName = this.translate.instant('EnergyAnalysis.hour')
        break;
      case 'week':
        const weekStart = moment(date).startOf('week')
        this.xAxisName = this.translate.instant('EnergyAnalysis.DateX')
        res = [
          weekStart,
          weekStart.clone().add(1,'day'),
          weekStart.clone().add(2,'day'),
          weekStart.clone().add(3,'day'),
          weekStart.clone().add(4,'day'),
          weekStart.clone().add(5,'day'),
          weekStart.clone().add(6,'day'),
        ].map(x => x.format('DD'))
        break;
      case 'month':
        let j = 1;
        const len = moment(date).daysInMonth();
        while (j <= len) {
          let str = '0' + j
          res.push(str.slice(str.length - 2))
          j++
        }
        this.xAxisName = this.translate.instant('EnergyAnalysis.DateX')
        break;
      case 'quarter':
        const quarter = Math.floor((moment(date).month() + 3) / 3);
        res = [3*quarter - 2, 3*quarter - 1, 3*quarter].map(x => {
          const str = '0' + x
          return str.slice(str.length - 2)
        })
        this.xAxisName = this.translate.instant('EnergyAnalysis.month')
        break;
      case 'year':
        let x = 1;
        while (x <= 12) {
          let str = '0' + x
          res.push(str.slice(str.length - 2))
          x++
        }
        this.xAxisName = this.translate.instant('EnergyAnalysis.month')
        break;
      default:
        break;
    }

    return res
  }

  export function getRGB(len) {
    const colors = []
    let i = 0
    while(i < len) {
      const r = (Math.floor(Math.random()*256).toString(16))
      const g = (Math.floor(Math.random()*256).toString(16))
      const b = (Math.floor(Math.random()*256).toString(16))
      colors.push(`#${r}${g}${b}`)
      i ++
    }
    return colors
  }

  export function getTimeInfo(dateType, date, str) {
    switch(dateType) {
      case 'date':
        str = str + ' : 00'
        break;
      case 'week':
        const day = Number(date.startOf('week').format('DD'))
        if(day > Number(str)) {
          str = date.clone().add(1,'month').format('MM') + '-' + str
        } else { 
          str = date.format('MM') + '-' + str
        }
        break;
      case 'month':
        const monthStr = '0' + (date.month() + 1) 
        str = monthStr.slice(monthStr.length - 2) + '-' + str
        break;
      case 'quarter':
        str = date.year() + '-' + str
        break;
      case 'year':
        const year = date.year()
        str = year + '-' + str
        break;
      default:
        break;
    }
    return str
  }

